export var DataType;
(function (DataType) {
    DataType["VFXItemData"] = "VFXItemData";
    // Assets
    DataType["Material"] = "Material";
    DataType["Shader"] = "Shader";
    DataType["Geometry"] = "Geometry";
    DataType["Texture"] = "Texture";
    DataType["Image"] = "Image";
    DataType["AnimationClip"] = "AnimationClip";
    DataType["BinaryAsset"] = "BinaryAsset";
    // Timeline
    DataType["TrackAsset"] = "TrackAsset";
    DataType["TimelineAsset"] = "TimelineAsset";
    DataType["ObjectBindingTrack"] = "ObjectBindingTrack";
    DataType["TransformTrack"] = "TransformTrack";
    DataType["SpriteColorTrack"] = "SpriteColorTrack";
    DataType["ActivationTrack"] = "ActivationTrack";
    DataType["SubCompositionTrack"] = "SubCompositionTrack";
    DataType["FloatPropertyTrack"] = "FloatPropertyTrack";
    DataType["ColorPropertyTrack"] = "ColorPropertyTrack";
    DataType["Vector2PropertyTrack"] = "Vector2PropertyTrack";
    DataType["Vector3PropertyTrack"] = "Vector3PropertyTrack";
    DataType["Vector4PropertyTrack"] = "Vector4PropertyTrack";
    DataType["TransformPlayableAsset"] = "TransformPlayableAsset";
    DataType["SpriteColorPlayableAsset"] = "SpriteColorPlayableAsset";
    DataType["ActivationPlayableAsset"] = "ActivationPlayableAsset";
    DataType["SubCompositionPlayableAsset"] = "SubCompositionPlayableAsset";
    DataType["FloatPropertyPlayableAsset"] = "FloatPropertyPlayableAsset";
    DataType["ColorPropertyPlayableAsset"] = "ColorPropertyPlayableAsset";
    DataType["Vector2PropertyPlayableAsset"] = "Vector2PropertyPlayableAsset";
    DataType["Vector3PropertyPlayableAsset"] = "Vector3PropertyPlayableAsset";
    DataType["Vector4PropertyPlayableAsset"] = "Vector4PropertyPlayableAsset";
    // Components
    DataType["MeshComponent"] = "MeshComponent";
    DataType["SkyboxComponent"] = "SkyboxComponent";
    DataType["LightComponent"] = "LightComponent";
    DataType["CameraComponent"] = "CameraComponent";
    DataType["ModelPluginComponent"] = "ModelPluginComponent";
    DataType["TreeComponent"] = "TreeComponent";
    DataType["AnimationComponent"] = "AnimationComponent";
    DataType["SpineComponent"] = "SpineComponent";
    DataType["VideoComponent"] = "VideoComponent";
    DataType["AudioComponent"] = "AudioComponent";
    DataType["RichTextComponent"] = "RichTextComponent";
    DataType["OrientationComponent"] = "OrientationComponent";
    DataType["ShapeComponent"] = "ShapeComponent";
    DataType["SpriteComponent"] = "SpriteComponent";
    DataType["ParticleSystem"] = "ParticleSystem";
    DataType["InteractComponent"] = "InteractComponent";
    DataType["CameraController"] = "CameraController";
    DataType["PostProcessVolume"] = "PostProcessVolume";
    DataType["EffectComponent"] = "EffectComponent";
    DataType["TextComponent"] = "TextComponent";
    DataType["AnimationGraphAsset"] = "AnimationGraphAsset";
    DataType["CompositionComponent"] = "CompositionComponent";
    DataType["FFDComponent"] = "FFDComponent";
    DataType["Animator"] = "Animator";
    // Non-EffectObject
    DataType["TimelineClip"] = "TimelineClip";
})(DataType || (DataType = {}));
